import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';

const pulse = keyframes`
  0%, 100% {
    transform: translate(-50%, -50%) scale(1);
    opacity: 0.15;
  }
  50% {
    transform: translate(-50%, -50%) scale(1.2);
    opacity: 0.25;
  }
`;

const flicker = keyframes`
  0%, 100% { opacity: 1; }
  41% { opacity: 1; }
  42% { opacity: 0.6; }
  43% { opacity: 1; }
  45% { opacity: 0.2; }
  46% { opacity: 1; }
`;

export const NotFoundBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 70vh;
  text-align: center;
  position: relative;
  overflow: hidden;
  padding: 20px;

  > p {
    font-size: 15px;
    color: #3d6e3d;
    max-width: 400px;
    margin-bottom: 32px;
  }
`;

export const GlowCircle = styled.div`
  position: absolute;
  top: 40%;
  left: 50%;
  width: 300px;
  height: 300px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(0, 255, 136, 0.2) 0%, transparent 70%);
  transform: translate(-50%, -50%);
  animation: ${pulse} 4s ease-in-out infinite;
  pointer-events: none;

  @media (min-width: 768px) {
    width: 500px;
    height: 500px;
  }
`;

export const GlitchTitle = styled.h1`
  font-size: 120px;
  font-weight: 900;
  color: #00ff88;
  letter-spacing: -4px;
  line-height: 1;
  margin-bottom: 8px;
  text-shadow:
    0 0 20px rgba(0, 255, 136, 0.5),
    0 0 60px rgba(0, 255, 136, 0.2),
    0 0 100px rgba(0, 255, 136, 0.1);
  animation: ${flicker} 5s infinite;
  position: relative;
  z-index: 1;

  @media (min-width: 768px) {
    font-size: 180px;
  }
`;

export const Subtitle = styled.h2`
  font-size: 20px;
  font-weight: 600;
  color: #e0e0e0;
  margin-bottom: 12px;
  text-transform: uppercase;
  letter-spacing: 4px;
  position: relative;
  z-index: 1;

  @media (min-width: 768px) {
    font-size: 24px;
  }
`;

export const HomeButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 14px 32px;
  font-size: 14px;
  font-weight: 600;
  font-family: inherit;
  color: #00ff88;
  background: rgba(0, 255, 136, 0.08);
  border: 1px solid rgba(0, 255, 136, 0.25);
  border-radius: 10px;
  cursor: pointer;
  text-decoration: none;
  text-transform: uppercase;
  letter-spacing: 1px;
  transition: all 0.2s ease;
  position: relative;
  z-index: 1;

  &:hover {
    background: rgba(0, 255, 136, 0.15);
    border-color: rgba(0, 255, 136, 0.5);
    box-shadow: 0 0 24px rgba(0, 255, 136, 0.2);
  }
`;
